import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  modal: boolean
}

const bp = 'sm'

const specialItemWidth = '175px'

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    position: 'inherit',
    marginTop: ({ modal }) => (modal ? '-19px' : '-1.25rem'),

    [theme.breakpoints.down(bp)]: {
      marginTop: ({ modal }) => (modal ? '1rem' : '-1.25rem')
    }
  },

  infoColumn: {
    marginBottom: '0',
    width: '100%',
    paddingTop: '0',
    columnCount: 2,
    columnGap: '0',

    '& > :first-child': {
      marginTop: '0'
    },

    [theme.breakpoints.down(bp)]: {
      columnCount: 1
    }
  },

  modalGrid: {
    [theme.breakpoints.down(bp)]: {
      marginTop: '0.5rem !important'
    }
  },

  specialItem: {
    '& > div': {
      height: '35px',

      '& > span': {
        minWidth: specialItemWidth,
        width: specialItemWidth,
        maxWidth: specialItemWidth,
        cursor: 'default',

        [theme.breakpoints.down(bp)]: {
          minWidth: 'revert',
          width: 'revert',
          maxWidth: 'revert',
          marginRight: '0'
        }
      },

      [theme.breakpoints.down(bp)]: {
        flexBasis: '-moz-available',
        height: 'auto'
      }
    },

    [theme.breakpoints.down(bp)]: {
      paddingTop: '1rem',
      fontSize: theme.size.sm
    }
  },

  group: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    overflow: 'auto',

    [theme.breakpoints.down('md')]: {
      fontSize: theme.size.sm
    }
  },

  title: {
    flexBasis: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingTop: '1.5rem',
    color: '#323436',
    fontSize: theme.size.sm,

    '& > :nth-child(2)': {
      opacity: '0.35',
      color: '#323436',
      fontSize: theme.size.sm,
      fontStyle: 'italic'
    },

    [theme.breakpoints.down('lg')]: {
      paddingTop: '0',
      paddingBottom: '0.5rem'
    }
  },

  gridContainer: {
    display: 'grid',
    // Creates two equal width columns
    gridTemplateColumns: 'repeat(2, 1fr)',
    width: '100%',
    fontSize: theme.size.sm,

    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  }
}))

export default useStyles
